import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import Banner from '../components/Banner'
import pic01 from '../assets/images/business.jpg'
import pic02 from '../assets/images/values.jpg'
import pic03 from '../assets/images/group2.jpg'
import favicon from '../assets/images/favicon.ico'

class HomeIndex extends React.Component {
    render() {
        const siteTitle = this.props.data.site.siteMetadata.title
        const siteDescription = this.props.data.site.siteMetadata.description

        return (
            <div>
                <Helmet>
                    <title>{siteTitle}</title>
                    <meta name="description" content={siteDescription} />
                    <link rel="shortcut icon" type="image/png" href={favicon} />
                </Helmet>
Business
                <Banner />

                <div id="main">
                    <section id="one" className="tiles">
                        <article style={{backgroundImage: `url(${pic01})`}}>
                            <header className="major">
                                <h3>Grupo</h3>
                                <p></p>
                            </header>
                            <Link to="/group" className="link primary"></Link>
                        </article>
                        <article style={{backgroundImage: `url(${pic03})`}}>
                            <header className="major">
                                <h3>Áreas de Negócio</h3>
                                <p></p>
                            </header>
                            <Link to="/fields" className="link primary"></Link>
                        </article>
                        <article className="imageContainer" style={{backgroundImage: `url(${pic02})`}}>
                           <header className="majority">
                                <h3>Valores</h3>
                                <p></p>
                            </header>
                            <Link to="/values" className="link primary"></Link>
                        </article>
                    </section>
                    <section id="two">
                        <div className="inner">
                            <header className="major">
                                <h2><font color="black">Sobre a AH Bussiness</font></h2>
                            </header>
                            <p>A AH BUSINESS nasce em Setembro de 2004 como resultado do cruzamento de duas fortes vocações: empreendedorismo e gestão.<br/><br/>
                            
                            A AHBUSINESS assume o compromisso de detetar potencial em empresas,
                            adquirir participação e responsabilizar-se pela gestão, no sentido de as converter
                            em atividades atrativas e rentáveis para o sector e acionistas.
                            A vontade de fazer crescer a AH BUSINESS tem assim, associada à capacidade de visualizar oportunidades de negócio, a capacidade de lhes dar corpo e vida. A história profissional e pessoal de cada um é, através da AH BUSINESS, assimilada e conduzida no sentido de lhe proporcionar um “nascimento” seguro e um crescimento com futuro.
                            A AHBUSINESS vê-se então como uma equipa de gestão de um portfólio de negócios
                            diversificado e, simultaneamente, de referência no setor respetivo.</p>
                            <ul className="actions">
                                <li><Link to="/group" className="button next">Ver mais</Link></li>
                            </ul>
                        </div>
                    </section>
                </div>

            </div>
        )
    }
}

export default HomeIndex

export const pageQuery = graphql`
    query PageQuery {
        site {
            siteMetadata {
                title
                description
            }
        }
    }
`



// WEBPACK FOOTER //
// ./src/pages/index.js